module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Disagreeing Virtuously: Religious Conflict in Interdisciplinary Perspective")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "TocSb2",
    attrs: {
      "id": "list"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/list#list"
    }
  }, [_vm._v("List of Tables and Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/foreword#for"
    }
  }, [_vm._v("Foreword, "), _c('span', {
    staticClass: "normal"
  }, [_vm._v("by Rob Barrett")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/acknowledgments#ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb3",
    attrs: {
      "id": "intro"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_vm._v("Introduction: We Are All Heretics Now")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "intro1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro1"
    }
  }, [_vm._v("The Heretical Imperative")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "intro2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro2"
    }
  }, [_vm._v("Defining Disagreement")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc3",
    attrs: {
      "id": "intro3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro3"
    }
  }, [_vm._v("Structure of the Book")])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ch001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("We Have Been Here Before")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s01"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s01"
    }
  }, [_vm._v("1.1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Malleable Men and the Council of the Wise: Plato and Aristotle")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s02"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s02"
    }
  }, [_vm._v("1.2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Varieties of Goodness: Augustine and Aquinas")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s03"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s03"
    }
  }, [_vm._v("1.3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Method Men: Bacon and Descartes")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s04"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s04"
    }
  }, [_vm._v("1.4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("From Natural War to Perpetual Peace: Hobbes, Locke, and Kant")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s05"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s05"
    }
  }, [_vm._v("1.5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Beyond Enlightenment: Nietzsche, Hamann, and Contemporary Voices")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ch002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Programmed to Disagree?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s06"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Constrained and Confused Minds")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s07"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Nature of Human Rationality and Decision-Making")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s08"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Cognitive Biases")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s09"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Two Hemispheres, Two Ways of Thinking")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("On Being Right(eous)")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter002#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.6."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Human Cognition and Religious Disagreement")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ch003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Science, Philosophy, and Religious Disagreement")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Scientific Perspectives on Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Naturalistic Accounts of Religion")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Religion and Violence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Philosophy of Religious Disagreement")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.5."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Reacting to Disagreement: A Dynamic View")])])]), _vm._v(" "), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "ch004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Disagreeing Virtuously")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.1."), _c('span', {
    staticClass: "space"
  }, [_vm._v("The Nature of Virtue")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.2."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Virtues of Disagreement")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.3."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Tolerance as a Virtue")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.4."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Religious Disagreement and Virtue")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0